import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { servicesApiKeyStore } from '../../../api/masters/services-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormInputTime } from '../../../components/hook-form/form-input.time.component';
import { ReactHookForm } from '../../../components/hook-form/react-hook-form.component';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { useLoadData } from '../../../hooks/useLoadData';
import { useReactHookForm } from '../../../hooks/useReactHookForm';
import { ApiResponse } from '../../../models/api-response';
import CloseIcon from '@mui/icons-material/Close';
import { useSaveData } from '../../../hooks/useSaveData';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';

interface WideCutOffTime {
  serviceMasterSettingsID: number;
  cutOffTime: string;
}

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
};

export const ServicesWideCutoffTime = () => {
  const form = useReactHookForm({
    defaultValues: {
      wideCutoffTime: '',
    },
  });
  const { data, refetch } = useLoadData<ApiResponse<any>>(servicesApiKeyStore.getWideCutoffTime());
  const { isLoading, mutateAsync } = useSaveData<any>(servicesApiKeyStore.updateWideCutoffTime());

  useEffect(() => {
    if (data?.data) {
      form.setValue('wideCutoffTime', data?.data?.cutOffTime);
    }
  }, [data]);

  const [editItem, setEditItem] = useState<Partial<WideCutOffTime>>();
  const handleEditClose = () => {
    setEditItem(undefined);
  };

  const handleSubmitdata = async (data: any) => { };

  const handleSave = async (data: any) => {
    const submitData = {
      cutOffTime: form.getValues('cutOffTime'),
      serviceMasterSettingsID: editItem?.serviceMasterSettingsID,
    };

    await mutateAsync({
      data: submitData,
    });
    handleEditClose();
    refetch();
  };

  const watchValue = form?.watch('cutOffTime');

  const handleEditWideCutoffTime = () => {
    setEditItem({
      cutOffTime: !data?.data?.cutOffTime ? '' : data?.data?.cutOffTime,
      serviceMasterSettingsID: !data?.data?.serviceMasterSettingsID ? 0 : data?.data?.serviceMasterSettingsID,
    });
    form.setValue('cutOffTime', !data?.data?.cutOffTime ? '' : data?.data?.cutOffTime);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <>
      <ReactHookForm formName="BULK_SCHEDULING_FORM" onSubmit={handleSubmitdata} formContextProps={form}>
        <div style={{ width: '100%', display: 'flex' }}>
          <FormInput label="System Cut-off Time" name="wideCutoffTime" maxLength={150} disabled />
          <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_SERVICE]}>
            <Button
              style={{ marginLeft: '5px' }}
              size="small"
              variant="contained"
              disableElevation={true}
              onClick={handleEditWideCutoffTime}
            >
              Edit
            </Button>
          </GuardedComponent>
        </div>
        {/* {editItem && (
          <SaveHookFormDialog
            title={'Edit Wide Cutoff time'}
            config={{
              saveConfig: servicesApiKeyStore.updateWideCutoffTime(),
            }}
            formatSubmitdata={formatSubmitdata}
            data={editItem}
            // yupSchema={serviceFormSchema}
            onClose={handleEditClose}
            size="md"
          >
            <FormInputTime name="cutOffTime" label="Cut-off Time" />
          </SaveHookFormDialog>
        )} */}
        <Dialog
          open={!!editItem}
          fullWidth={true}
          maxWidth={'xs'}
          // onClose={handleEditClose}
          aria-labelledby="dialog-title"
          aria-describedby="dialog-description"
        >
          <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
            Edit Cut-off Time
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleEditClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 3,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Tooltip title={<Typography variant="body1">Close</Typography>}>
              <CloseIcon />
            </Tooltip>
          </IconButton>
          <DialogContent dividers style={styling.contentPadding} className="popupDilog">
            {isLoading && <LoadingIndicator isLoading={isLoading} isSpinner={false} />}
            <FormInputTime name="cutOffTime" label="Cut-off Time" />
          </DialogContent>
          <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
            <DialogActions className="spaceBetween">
              <Button variant="outlined" style={{ width: '130px' }} onClick={handleEditClose}>
                Cancel
              </Button>
              <Button
                disabled={watchValue === 'Invalid Date' || isReadOnlyPermission}
                onClick={handleSave}
                variant="contained"
                style={{ width: '130px' }}
              >
                Save
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </ReactHookForm>
    </>
  );
};
